import { PostType } from 'src/graphql/generated';

export const shouldShowPaidAggregatedAdBanner = (postType: PostType) =>
  postType === PostType.PAID_AGGREGATION;
